<template>
    <path
        fill-rule="evenodd"
        d="M5 3.5h6A2.5 2.5 0 0 1 13.5 6v4a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 10V6A2.5 2.5 0 0 1 5 3.5Zm0 .9A1.6 1.6 0 0 0 3.4 6v4A1.6 1.6 0 0 0 5 11.6h6A1.6 1.6 0 0 0 12.6 10V6A1.6 1.6 0 0 0 11 4.4H5Zm.25 2h5.5a.45.45 0 0 1 0 .9h-5.5a.45.45 0 0 1 0-.9Zm0 2h3.5a.45.45 0 0 1 0 .9h-3.5a.45.45 0 0 1 0-.9Z"
    />
</template>
